import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router';

interface RouteState {
  code?: string;
  message: string;
}

type MessagePageProps = RouteComponentProps<never, never, RouteState>;

const MessagePage: FC<MessagePageProps> = ({ location }) => {
  return (
    <div className='message'>
      {location.state.code && <h1 className='message__code'>{location.state.code}</h1>}
      <p className='message__content'>{location.state.message}</p>
    </div>
  );
};

export default MessagePage;
